export const useElbwalker = () => {
  if (!isClient)
    return

  const checkoutStore = useCheckoutStore()

  const cartTotal = computed(() => (checkoutStore.totalPrice?.cost ?? 0) / 100)

  const { orderData } = useOrderStore()

  window.elbLayer = window.elbLayer || []

  const consentVisibleEvent = () => {
    window.elbLayer.push('visible consent', {}, 'visible')
  }

  const allAcceptedEvent = () => {
    window.elbLayer.push('granted consent', {}, 'click')
  }

  const saveAndExitEvent = () => {
    window.elbLayer.push('denied consent', {}, 'click')
  }

  const purchaseEvent = () => {
    window.elbLayer.push(
      'transaction purchase',
      { Total_amount: cartTotal, Transaction_ID: orderData.orderCode },
      'load',
    )
  }

  const { load: init } = useScriptTag('https://walker.p.elbwalkerapis.com/walker.js', undefined, {
    manual: true,
    async: true,
    attrs: {
      'class': 'elbwalker',
      'data-project': 'AQ9CJEV',
    },
  })

  return { init, consentVisibleEvent, allAcceptedEvent, saveAndExitEvent, purchaseEvent }
}
